import { render } from "./bubblesView.vue?vue&type=template&id=4179aa92&ts=true"
import script from "./bubblesView.vue?vue&type=script&lang=ts"
export * from "./bubblesView.vue?vue&type=script&lang=ts"

import "./bubblesView.vue?vue&type=style&index=0&id=4179aa92&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__